import { render, staticRenderFns } from "./EditarCertificadoModal.vue?vue&type=template&id=413a3ef7&"
import script from "./EditarCertificadoModal.vue?vue&type=script&lang=ts&"
export * from "./EditarCertificadoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('413a3ef7', component.options)
    } else {
      api.reload('413a3ef7', component.options)
    }
    module.hot.accept("./EditarCertificadoModal.vue?vue&type=template&id=413a3ef7&", function () {
      api.rerender('413a3ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/EditarCertificadoModal.vue"
export default component.exports